import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
// 30/10/2026 (auditoría): el Vault ya no se abre con credenciales escritas en el JS; pide la sesión del dueño.
import VaultGuard from './components/VaultGuard';
import CookieConsent from './components/CookieConsent';

// Pages
import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import NewProject from './pages/NewProject';
import Settings from './pages/Settings';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ActivityHistory from './pages/ActivityHistory';
import BeginnerGuide from './pages/BeginnerGuide';
import LegalNotice from './pages/LegalNotice';
import Terms from './pages/Terms';
import CookiesPolicy from './pages/CookiesPolicy';
import Contact from './pages/Contact';
import GettingStarted from './pages/GettingStarted';
import ShareProject from './pages/ShareProject';

// Existing components
import RoadmapDinamico from './RoadmapDinamico';
import DemoRoadmap from './DemoRoadmap';
import DocsPage from './DocsPage';
import VaultDashboard from './VaultDashboard';
import BrandBook from './BrandBook';

import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="App">
          <CookieConsent />
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Landing />} />
            <Route path="/start" element={<GettingStarted />} />
            <Route path="/guide" element={<BeginnerGuide />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            {/* Legal pages */}
            <Route path="/legal" element={<LegalNotice />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/cookies" element={<CookiesPolicy />} />
            <Route path="/contact" element={<Contact />} />

            {/* Protected routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/new-project" element={
              <ProtectedRoute>
                <NewProject />
              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            } />
            <Route path="/project/:projectId/share" element={
              <ProtectedRoute>
                <ShareProject />
              </ProtectedRoute>
            } />

            {/* Public Demo */}
            <Route path="/demo" element={<DemoRoadmap />} />

            {/* Project routes - FIXARR requires auth */}
            <Route path="/project/fixarr" element={
              <ProtectedRoute>
                <RoadmapDinamico />
              </ProtectedRoute>
            } />
            <Route path="/project/:projectId" element={
              <ProtectedRoute>
                <RoadmapDinamico />
              </ProtectedRoute>
            } />

            {/* Project-specific routes */}
            <Route path="/project/fixarr/docs" element={<DocsPage />} />
            <Route path="/project/fixarr/docs/:taskId" element={<DocsPage />} />
            <Route path="/project/fixarr/vault" element={<VaultGuard><VaultDashboard /></VaultGuard>} />
            <Route path="/project/fixarr/vault/login" element={<Navigate to="/project/fixarr/vault" replace />} />
            <Route path="/project/fixarr/brand-book" element={<BrandBook />} />

            {/* Activity History */}
            <Route path="/activity" element={<ActivityHistory />} />
            <Route path="/project/fixarr/activity" element={<ActivityHistory />} />

            {/* Legacy routes (redirect to /project/fixarr) */}
            <Route path="/docs" element={<DocsPage />} />
            <Route path="/docs/:taskId" element={<DocsPage />} />
            <Route path="/vault" element={<VaultGuard><VaultDashboard /></VaultGuard>} />
            <Route path="/vault/login" element={<Navigate to="/vault" replace />} />
            <Route path="/brand-book" element={<BrandBook />} />
          </Routes>
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
